import { JsonReaderService } from 'src/app/services/json-reader/json-reader.service';
import { UserSettingsService } from 'src/app/services/user-settings/user-settings.service';
export type AchievementMissionType = 'craftitemfame' | 'killmobfame' | 'farmraisefame' | 'farmharvestfame' | 'gatherfame' | 'trackingfame';
export type AchievementBonusType =
  | 'trackingtimereduction'
  | 'trackingtargetchancemodifier'
  | 'itemwearbonus'
  | 'resourcegatherbonus'
  | 'farmingfocuscostreduction'
  | 'craftingfocuscostreduction'
  | 'itemcraftquality';
export class Achievement {
  useTemplate!: string;
  missionType!: AchievementMissionType;
  id!: string;
  category!: string;
  itemForSprite!: string;
  isFameAchievement!: boolean;
  achievementBonus?: AchievementBonus[];
  playerLevel?: number;
  constructor(
    private jsonReaderService: JsonReaderService,
    private userSettingsService: UserSettingsService
  ) {}
  get localizedName(): string {
    return this.jsonReaderService.getDestinyBoardLocalizedName(this.id, this.userSettingsService.getUserLanguage()) ?? '';
  }
}

export interface AchievementBonus {
  type: AchievementBonusType;
  bonus: number;
  minTier: number;
  maxTier: number;
  itemPattern?: string[];
}
